import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosPrivate from "../../api/axiosPrivate";
import axiosPublic from "../../api/axiosPublic";

export const verifyBvn = createAsyncThunk(
  "verify/bvn",
  async (bvn, { rejectWithValue }) => {
    try {
      const { data } = await axiosPublic.get(`verify/bvn/${bvn}`);

      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
